export const common = {
  siteName: 'CSSBuy Spreadsheet',
  siteDomain: 'cssbuybr.run',
  mainSite: 'https://kaspreadsheet.com',
  language: 'Deutsch',
  nav: {
    home: 'Startseite',
    products: 'Produkte',
    guides: 'Ratgeber',
    review: 'Bewertung',
    shipping: 'Versand',
    qc: 'Qualitätskontrolle',
    warehouse: 'Lager',
    sellers: 'Verkäufer',
    comparisons: 'Vergleiche',
    safety: 'Sicherheit',
    about: 'Über uns',
    contact: 'Kontakt',
  },
  buttons: {
    explore: 'CSSBuy Spreadsheet entdecken',
    buyNow: 'Jetzt kaufen',
    viewGuides: 'Kaufratgeber ansehen',
    mainSite: 'CSSBuy Spreadsheet',
    shopNow: 'Jetzt shoppen',
    readMore: 'Mehr lesen',
    backToHome: 'Zurück zur Startseite',
  },
  categories: {
    title: 'Produktkategorien',
    subtitle: 'Durchsuchen Sie verifizierte Produkte nach Kategorie auf unserer Hauptseite',
    shoes: 'Schuhe',
    hoodiesSweaters: 'Hoodies / Pullover',
    tShirts: 'T-Shirts',
    jackets: 'Jacken',
    pantsShorts: 'Hosen / Shorts',
    headwear: 'Kopfbedeckungen',
    sets: 'Sets',
    underwear: 'Unterwäsche / Unterhosen',
    jersey: 'Trikot',
    accessories: 'Accessoires',
    bags: 'Taschen',
    belts: 'Gürtel',
    perfumes: 'Parfums',
    otherStuff: 'Sonstiges',
  },
  hero: {
    h1: 'CSSBuy Spreadsheet: Produkte, Verkäufer und Einkaufsratgeber',
    description:
      'Suchen Sie ein CSSBuy Spreadsheet, um Produkte, Verkäufer und Einkaufsressourcen einfacher zu finden? Entdecken Sie Ratgeber, Vergleiche, QC-Informationen, Lagerdetails, Versandtipps und praktische Ratschläge für bessere Recherche vor dem Kauf.',
  },
  popularResources: {
    title: 'Beliebte Ressourcen',
    subtitle: 'Alles, was Sie über CSSBuy wissen müssen',
    items: {
      spreadsheet: 'CSSBuy Spreadsheet',
      review: 'CSSBuy Bewertung',
      shipping: 'CSSBuy Versandkosten',
      coupon: 'CSSBuy Gutschein',
      discount: 'CSSBuy Rabattcode',
      warehouse: 'CSSBuy Lager',
      legit: 'Ist CSSBuy seriös?',
      qc: 'CSSBuy Qualitätskontrolle',
      sellers: 'CSSBuy Verkäufer',
    },
  },
  ctaSection: {
    title: 'Bereit zum Einkaufen?',
    description:
      'Besuchen Sie unseren Hauptshop, um die vollständige CSSBuy Spreadsheet mit verifizierten Produkten, vertrauenswürdigen Verkäufern und exklusiven Angeboten zu durchsuchen.',
    button1: 'CSSBuy Spreadsheet',
    button2: 'Jetzt kaufen',
  },
  footer: {
    disclaimer:
      'Diese Website ist eine unabhängige Informationsressource und nicht offiziell mit CSSBuy verbunden oder von CSSBuy unterstützt.',
    quickLinks: 'Schnelllinks',
    resources: 'Ressourcen',
    legal: 'Rechtliches',
    editorial: 'Redaktionelle Richtlinien',
    disclaimerPage: 'Haftungsausschluss',
    privacy: 'Datenschutzrichtlinie',
    terms: 'Nutzungsbedingungen',
    copyright: '© {year} cssbuybr.run. Alle Rechte vorbehalten.',
  },
  article: {
    published: 'Veröffentlicht',
    updated: 'Aktualisiert',
    minRead: 'Min. Lesezeit',
    tableOfContents: 'Inhaltsverzeichnis',
    relatedArticles: 'Verwandte Artikel',
    faq: 'Häufig gestellte Fragen',
  },
  home: {
    latestGuides: 'Aktuelle Ratgeber',
    latestGuidesSubtitle: 'Entdecken Sie unsere ausführlichen Ratgeber und Ressourcen für intelligenteres Einkaufen',
    pillarTitle: 'CSSBuy Spreadsheet Ratgeber',
    pillarSubtitle: 'Ausführliche Pillar-Artikel, die Ihnen helfen, intelligenter mit CSSBuy einzukaufen',
  },
  meta: {
    homeTitle: 'CSSBuy Spreadsheet: Produkte, Verkäufer und Kaufratgeber 2026',
    homeDescription:
      'Das komplette CSSBuy Spreadsheet Ressourcen-Center. Finden Sie Produkte, Verkäufer, QC-Ratgeber, Versandinformationen, Lagerdetails und Kauftipps für CSSBuy in 2026.',
  },
  products: {
    title: 'Empfohlene Produkte',
    subtitle: 'Durchsuchen Sie kuratierte Produkte aus unserer Tabelle. Klicken Sie auf einen Artikel, um Details anzusehen und auf unserer Partnerseite zu kaufen.',
    viewAll: 'Alle Produkte anzeigen',
    pageTitle: 'Alle Produkte',
    pageDescription: 'Durchsuchen Sie alle kuratierten Produkte aus unserer Tabelle. Klicken Sie auf einen Artikel, um Details anzusehen und auf unserer Partnerseite zu kaufen.',
    items: 'Produkte',
    categories: 'Kategorien',
    all: 'Alle',
  },
};